/* eslint-disable import/no-relative-parent-imports */
import { DESKTOP_BREAKPOINT } from "../src/constants/constants"

function generateConfig() {
  const colors = {
    // Primary Colors
    "primary-20": "#e5f1f7",
    "primary-30": "#89dcff",
    "primary-40": "#67c3ef",
    "primary-50": "#0078ad",
    "primary-60": "#0c5273",
    "primary-70": "#00364e",
    "primary-80": "#001e2b",
    "primary-inverse": "#ffffff",
    "primary-background": "#ffffff",
    "primary-grey-100": "#141414",
    "primary-grey-80": "rgba(0, 0, 0, .65)",
    "primary-grey-60": "#b5b5b5",
    "primary-grey-40": "#e0e0e0",
    "primary-grey-20": "#f5f5f5",

    // Secondary Colors
    "secondary-20": "#fce6e7",
    "secondary-30": "#ff9da3",
    "secondary-40": "#fc6770",
    "secondary-50": "#e30513",
    "secondary-60": "#a80000",
    "secondary-70": "#660209",
    "secondary-80": "#390105",
    "secondary-inverse": "#ffffff",
    "secondary-background": "#ffffff",
    "secondary-grey-100": "#141414",
    "secondary-grey-80": "rgba(0, 0, 0, .65)",
    "secondary-grey-60": "#b5b5b5",
    "secondary-grey-40": "#e0e0e0",
    "secondary-grey-20": "#f5f5f5",

    // Tertiary aka Sparkle Colors
    "sparkle-20": "#e5f7ee",
    "sparkle-30": "#94f6c5",
    "sparkle-40": "#10d974",
    "sparkle-50": "#00b259",
    "sparkle-60": "#03753c",
    "sparkle-70": "#005028",
    "sparkle-80": "#002d16",
    "sparkle-inverse": "#002d16",
    "sparkle-background": "#ffffff",
    "sparkle-grey-100": "#141414",
    "sparkle-grey-80": "rgba(0, 0, 0, .65)",
    "sparkle-grey-60": "#b5b5b5",
    "sparkle-grey-40": "#e0e0e0",
    "sparkle-grey-20": "#f5f5f5",

    // Semantic Colors
    white: "#ffffff",
    black: "#141414",

    "error-80": "#660014",
    "error-50": "#f50031",
    "error-20": "#fee6ea",

    "warning-80": "#7d2f08",
    "warning-50": "#f06d0f",
    "warning-20": "#fef0e7",

    "success-80": "#135610",
    "success-50": "#25ab21",
    "success-20": "#e9f7e9",

    "marigold-40": "#FFD947",
    "marigold-50": "#F7AB20",
  }

  const fontSize = {
    "heading-m": [
      "40px",
      {
        lineHeight: "44px",
        // letterSpacing: '-0.03em',
        fontWeight: "900",
      },
    ],
    "heading-s": [
      "32px",
      {
        lineHeight: "36px",
        // letterSpacing: '-0.03em',
        fontWeight: "900",
      },
    ],
    "heading-xs": [
      "24px",
      {
        lineHeight: "32px",
        // letterSpacing: '-0.03em',
        fontWeight: "900",
      },
    ],
    "heading-xxs": [
      "16px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.03em',
        fontWeight: "900",
      },
    ],
    "body-l": [
      "24px",
      {
        lineHeight: "32px",
        // letterSpacing: '-0.05em',
        fontWeight: "500",
      },
    ],
    "body-l-light": [
      "24px",
      {
        lineHeight: "32px",
        // letterSpacing: '-0.05em',
        fontWeight: "300",
      },
    ],
    "body-l-bold": [
      "24px",
      {
        lineHeight: "32px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-l-link": [
      "24px",
      {
        lineHeight: "32px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-m": [
      "18px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "500",
      },
    ],
    "body-m-light": [
      "18px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "300",
      },
    ],
    "body-m-bold": [
      "18px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-m-link": [
      "18px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-s": [
      "16px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "500",
      },
    ],
    "body-s-light": [
      "16px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "300",
      },
    ],
    "body-s-bold": [
      "16px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-s-link": [
      "16px",
      {
        lineHeight: "24px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-xs": [
      "14px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "500",
      },
    ],
    "body-xs-light": [
      "14px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "300",
      },
    ],
    "body-xs-bold": [
      "14px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-xs-link": [
      "14px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-xxs": [
      "12px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "500",
      },
    ],
    "body-xxs-light": [
      "12px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "300",
      },
    ],
    "body-xxs-bold": [
      "12px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
    "body-xxs-link": [
      "12px",
      {
        lineHeight: "16px",
        // letterSpacing: '-0.05em',
        fontWeight: "700",
      },
    ],
  }

  const spacing = {
    xxxs: "2px",
    xxs: "4px",
    xs: "8px",
    s: "12px",
    base: "16px",
    xm: "20px",
    m: "24px",
    l: "32px",
    xl: "40px",
    xxl: "48px",
    huge: "64px",
    massive: "80px",
  }

  const boxShadow = {
    s: `0px ${spacing["xxs"]} ${spacing["base"]} rgba(0, 0, 0, 0.08)`,
    m: `0px ${spacing["xxs"]} ${spacing["base"]} rgba(0, 0, 0, 0.16)`,
    l: `0px ${spacing["xxs"]} ${spacing["base"]} rgba(0, 0, 0, 0.24)`,
    primary: `0 0 0 ${spacing["xxs"]} ${colors["primary-80"]}`,
    success: `0 0 0 ${spacing["xxs"]} ${colors["success-50"]}`,
    error: `0 0 0 ${spacing["xxs"]} ${colors["error-50"]}`,
    warning: `0 0 0 ${spacing["xxs"]} ${colors["warning-50"]}`,
    sparkle: `0 0 0 ${spacing["xxs"]} ${colors["sparkle-80"]}`,
    drop: `0px ${spacing["xxs"]} ${spacing["xxs"]} rgba(0, 0, 0, 0.24)`,
  }

  const borderRadius = {
    small: spacing["xxs"],
    medium: spacing["xs"],
    large: spacing["base"],
    xl: spacing["m"],
    xxl: spacing["l"],
    pill: "250px",
  }

  const zIndex = {
    10: 10,
    20: 20,
    30: 30,
    40: 40,
    50: 50,
    60: 60,
    70: 70,
    100: 100,
    500: 500,
    1000: 1000,
  }

  const screens = {
    sm: { max: `${DESKTOP_BREAKPOINT - 1}px` },
    lg: { min: `${DESKTOP_BREAKPOINT}px` },
  }

  return {
    colors,
    fontSize,
    spacing,
    boxShadow,
    borderRadius,
    zIndex,
    screens,
  }
}

export const ajio = generateConfig()
